import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const assetTypeService = createApi({
    reducerPath: 'assetTypeService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['AssetType'],
    endpoints: (builder) => ({
        getAllAssetType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetTypeController.getAllAssetType}/${body.page}/${body.size}?orderBy=${body.sort}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAssetTypeById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetTypeController.getAssetTypeById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveAssetType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetTypeController.saveAssetType}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateAssetType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetTypeController.updateAssetType}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteAssetType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetTypeController.deleteAssetType}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllAssetTypeBySearch: builder.mutation({
            query(body) {
                console.log(body, "body");

                return {
                    url: `${userManagement.assetTypeController.getAllAssetTypeBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllAssetType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetTypeController.findAllAssetType}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveAssetType: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.assetTypeController.bulkSaveAssetType}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});
export const {
    useGetAllAssetTypeMutation,
    useGetAssetTypeByIdMutation,
    useSaveAssetTypeMutation,
    useUpdateAssetTypeMutation,
    useDeleteAssetTypeMutation,
    useGetAllAssetTypeBySearchMutation,
    useFindAllAssetTypeMutation,
    useBulkSaveAssetTypeMutation,
} = assetTypeService;